import { registerMockAPI } from '~/mocks/mockApis';

import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeCategoryType, TypeGetCategoriesTypesResponse } from '~/types/product.types';

/**
 * [상품관리] 카테고리 타입별 조회 API
 * @param type 카테고리 타입 (MAIN, MIDDLE, THIRD)
 */
export const fetchCategoriesTypesType = async (type: TypeCategoryType) => {
  const endpoint = '/api-lip/v1/categories/types';
  const { data } = await axiosInstance.get<TypeGetCategoriesTypesResponse>(`${endpoint}/${type}`);
  return data.data;
};

type UseGetCategoriesTypesTypeQueryOptions = {
  type: TypeCategoryType;
  enabled?: boolean;
  showGlobalDimOverlay?: boolean;
  showGlobalErrorToast?: boolean;
};

/**
 * [상품관리] 카테고리 타입별 조회 Query Hook
 * @description MAIN 카테고리일 경우 또는 카테고리 타입별로 조회가 필요할 경우 사용한다.
 */
export const useGetCategoriesTypesTypeQuery = ({
  type,
  enabled = true,
  showGlobalDimOverlay = true,
  showGlobalErrorToast = true,
}: UseGetCategoriesTypesTypeQueryOptions) => {
  return useQuery({
    queryKey: productKeys.categoriesTypes(type),
    queryFn: () => fetchCategoriesTypesType(type),
    staleTime: 1000 * 60 * 30, // 30분
    enabled,
    meta: { showGlobalDimOverlay, showGlobalErrorToast },
  });
};

const mainCategoriesResponse: TypeGetCategoriesTypesResponse = {
  data: [
    { type: 'MAIN', code: 'C01', name: '신선식품', parentCode: '' },
    { type: 'MAIN', code: 'C02', name: '가공식품', parentCode: '' },
    { type: 'MAIN', code: 'C03', name: '뷰티', parentCode: '' },
  ],
};

// 페이지 진입 시 MAIN 만 조회하므로 대분류 경로만 등록한다.
registerMockAPI<TypeGetCategoriesTypesResponse>({
  method: 'get',
  endpoint: '/api-lip/v1/categories/types/MAIN',
  label: ['상품/상품등록수정/대분류', '상품/운영상품조회/대분류'],
  scenarios: [{ name: '정상 응답', response: mainCategoriesResponse }],
});
